export default {
    ADD_UNDO: 'ADD_UNDO',
    ADD_REDO: 'ADD_REDO',
    UPDATE_UNDO: 'UPDATE_UNDO',
    UPDATE_REDO: 'UPDATE_REDO',
    RESET_UNDOREDO: 'RESET_UNDOREDO',
    UPDATE_POSITION: 'UPDATE_POSITION',
    POP_UNDO: 'POP_UNDO',
    POP_REDO: 'POP_REDO'
}